<template lang="pug">
.v-blogs.blogs(v-if="block")
	.blogs__cards
		.blogs__cards-wrapper
			button.blogs__arrow.blogs__arrow--prev(type="button" ref="blog-prev" aria-label="Предыдущий слайд")
				v-svg-icon.blogs__arrow-icon(icon="slide-left")
				v-svg-icon.blogs__arrow-bg(icon="slide-left-bg")
			button.blogs__arrow.blogs__arrow--next(type="button" ref="blog-next" aria-label="Следующий слайд")
				v-svg-icon.blogs__arrow-icon(icon="slide-right")
				v-svg-icon.blogs__arrow-bg(icon="slide-right-bg")
			v-swiper-slider.blogs__slider(:options="options"
					:navigation="navigation"
					@swiper="onSwiper")
				template(v-if="isMd")
					swiper-slide.blogs__slide(v-if="block.blogs.items && block.blogs.items.length"
							v-for="(blog, blogIndex) in block.blogs.items"
							:key="blogIndex")
						a.blogs__card-wrapper(:href="blog.link")
							img.blogs__card-img(:src="blog.image"
									loading="lazy"
									alt="")
							.blogs__card-text(v-if="blog.text") {{blog.text}}
							.blogs__card-date(v-if="blog.date") {{blog.date}}
				template(v-else)
					swiper-slide.blogs__slide(v-if="block.blogs.items && block.blogs.items.length"
							v-for="(blog, blogIndex) in block.blogs.items"
							:key="blogIndex")
						transition(name="fade")
							a.blogs__card-wrapper(:href="blog.link"	)
								img.blogs__card-img(
										:src="blog.image"
										loading="lazy"
										alt="")
								.blogs__card-text(v-if="blog.text") {{blog.text}}
								.blogs__card-date(v-if="blog.date") {{blog.date}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from '../scripts/breakpoints.js';
import {SwiperSlide} from 'swiper/vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	components: {
		SwiperSlide
	},

	data() {
		return {
			block: null,
			options: {
				loop: true,
				breakpoints: {
					[breakpoints['md-mid']]: {
						spaceBetween: 20,
						slidesPerView: 'auto'
					},
					[breakpoints['4xs-min']]: {
						spaceBetween: 12,
						slidesPerView: 'auto'
					}
				}
			},
			allowTouchMove: true,
			pagination: {
				clickable: false
			},
			navigation: false
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['blog-prev'],
				nextEl: this.$refs['blog-next']
			};
		},

		dataSet(data) {
			this.block = data;
		}
	}
};
</script>